import { ColumnType } from '@treelab/common-logic';
import { glyphs as Glyphs } from '@treelab/panda';

import { ElementTypes } from '../types/element';


export const FIELD_GLYPH_MAP = {
  [ColumnType.CHECKBOX]: Glyphs.FIELD_CHECKBOX,
  [ColumnType.DATETIME]: Glyphs.FIELD_DATE,
  [ColumnType.COLLABORATOR]: Glyphs.FIELD_COLLABORATOR,
  [ColumnType.CURRENCY]: Glyphs.FIELD_CURRENCY,
  [ColumnType.FORMULA]: Glyphs.FIELD_FORMULA,
  [ColumnType.LONG_TEXT]: Glyphs.FIELD_LONG_TEXT,
  [ColumnType.MULTI_ATTACHMENT]: Glyphs.FIELD_ATTACHMENT,
  [ColumnType.MULTI_SELECT]: Glyphs.FIELD_MULTI_SELECT,
  [ColumnType.NUMBER]: Glyphs.FIELD_NUMBER,
  [ColumnType.PHONE]: Glyphs.FIELD_PHONE,
  [ColumnType.EMAIL]: Glyphs.FIELD_EMAIL,
  [ColumnType.RATING]: Glyphs.FIELD_RATING,
  [ColumnType.RECORD_REFERENCE]: Glyphs.FIELD_RECORD_REF,
  [ColumnType.STATUS]: Glyphs.FIELD_STATUS,
  [ColumnType.SELECT]: Glyphs.FIELD_SELECT,
  [ColumnType.TEXT]: Glyphs.FIELD_TEXT,
  [ColumnType.AUTO_NUMBER]: Glyphs.FIELD_AUTO_NUMBER,
  [ColumnType.LOOKUP]: Glyphs.FIELD_LOOKUP,
  [ColumnType.ROLLUP]: Glyphs.FIELD_ROLLUP,
  [ElementTypes.StaticText]: Glyphs.FIELD_TEXT,
  [ElementTypes.StaticAttachment]: Glyphs.FIELD_ATTACHMENT,
  [ColumnType.UNIQUE_ID]: Glyphs.FIELD_UNIQUE_ID,
  [ColumnType.INTEGRATION_REFERENCE]: Glyphs.FIELD_TEXT,
  [ColumnType.NOOP]: Glyphs.FIELD_TEXT,
  [ColumnType.CREATED_AT]: Glyphs.FIELD_CREATED_AT,
  [ColumnType.CREATED_BY]: Glyphs.FIELD_CREATED_BY,
  [ColumnType.SUBTABLE]: Glyphs.FIELD_SUBTABLE,
};

export const FIELD_ELEMENT_TYPE_MAP = {
  [ColumnType.CHECKBOX]: ElementTypes.FieldCheckbox,
  [ColumnType.DATETIME]: ElementTypes.FieldDateTime,
  [ColumnType.COLLABORATOR]: ElementTypes.FieldCollaborator,
  [ColumnType.CURRENCY]: ElementTypes.FieldCurrency,
  [ColumnType.FORMULA]: ElementTypes.FieldFormula,
  [ColumnType.LONG_TEXT]: ElementTypes.FieldLongText,
  [ColumnType.MULTI_ATTACHMENT]: ElementTypes.FieldMultiAttachment,
  [ColumnType.MULTI_SELECT]: ElementTypes.FieldMultiSelect,
  [ColumnType.NUMBER]: ElementTypes.FieldNumber,
  [ColumnType.PHONE]: ElementTypes.FieldPhone,
  [ColumnType.EMAIL]: ElementTypes.FieldEmail,
  [ColumnType.RATING]: ElementTypes.FieldRating,
  [ColumnType.RECORD_REFERENCE]: ElementTypes.FieldRecordRef,
  [ColumnType.STATUS]: ElementTypes.FieldStatus,
  [ColumnType.SELECT]: ElementTypes.FieldSelect,
  [ColumnType.TEXT]: ElementTypes.FieldText,
  [ColumnType.AUTO_NUMBER]: ElementTypes.FieldAutoNumber,
  [ColumnType.LOOKUP]: ElementTypes.FieldLookup,
  [ColumnType.ROLLUP]: ElementTypes.FieldRollup,
  [ColumnType.UNIQUE_ID]: ElementTypes.FieldText,
  [ColumnType.INTEGRATION_REFERENCE]: null,
  [ColumnType.NOOP]: null,
  [ColumnType.CREATED_AT]: ElementTypes.FieldDateTime,
  [ColumnType.CREATED_BY]: ElementTypes.FieldCollaborator,
  [ColumnType.SUBTABLE]: ElementTypes.FieldSubtable,
};

export const FIELD_TYPE_VALIDATE = {
  [ColumnType.CHECKBOX]: true,
  [ColumnType.DATETIME]: true,
  [ColumnType.COLLABORATOR]: true,
  [ColumnType.CURRENCY]: true,
  [ColumnType.FORMULA]: true,
  [ColumnType.LONG_TEXT]: true,
  [ColumnType.MULTI_ATTACHMENT]: true,
  [ColumnType.MULTI_SELECT]: true,
  [ColumnType.NUMBER]: true,
  [ColumnType.PHONE]: true,
  [ColumnType.EMAIL]: true,
  [ColumnType.RATING]: true,
  [ColumnType.RECORD_REFERENCE]: true,
  [ColumnType.STATUS]: true,
  [ColumnType.SELECT]: true,
  [ColumnType.TEXT]: true,
  [ColumnType.AUTO_NUMBER]: true,
  [ColumnType.LOOKUP]: true,
  [ColumnType.ROLLUP]: true,
  [ColumnType.UNIQUE_ID]: true,
  [ColumnType.INTEGRATION_REFERENCE]: null,
  [ColumnType.NOOP]: null,
  [ColumnType.CREATED_AT]: true,
  [ColumnType.CREATED_BY]: true,
  [ColumnType.SUBTABLE]: true,
  [ColumnType.PROGRESS]: false,
}
